/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillProfilePhoto} from '../api'

export const useMutationBackfillProfilePhoto = createReactQueryMutationHook('backfillProfilePhoto', backfillProfilePhoto)
